import React from "react";
import "../Styles/Permission.css"

const Create = () => {
  return (
    <div className="create">
      <h4>Create New Role</h4>
    </div>
  );
};

export default Create;
